import { useQuery } from 'react-query';

import { ENDPOINT_WISHLISTS_TREE } from '@/common/constants';
import getWishlistsTree from '@/ebat/api/wishlists/getWishlistsTree';

const useWishlistsTree = (product) =>
  useQuery([ENDPOINT_WISHLISTS_TREE, product?.id], getWishlistsTree);

export default useWishlistsTree;
